import {
  LIST_PATIENT_MANAGEMENT_TYPE_REQUEST,
  LIST_PATIENT_MANAGEMENT_TYPE_SUCCESS,
  LIST_PATIENT_MANAGEMENT_TYPE_FAIL
} from '../../constants/patient-management'

const mappingModule = (module) => {
  switch (module) {
    case 'honorific':
      return 'honorifics'
    case 'ethnic':
      return 'ethnics'
    case 'language':
      return 'languages'
    case 'education':
      return 'educations'
    case 'profession':
      return 'professions'
    default:
      return ''
  }
}

const initialState = {
  loading: false,
  honorifics: [],
  ethnics: [],
  languages: [],
  educations: [],
  professions: [],
  patientProfessions: [],
  error: null,
  patientsManagementType: []
}

const mappingDataByModule = (module, data) => {
  switch (module) {
    case 'honorific':
      return {
        honorifics: data
      }
    case 'ethnic':
      return {
        ethnics: data
      }
    case 'language':
      return {
        languages: data
      }
    case 'education':
      return {
        educations: data
      }
    case 'profession':
      return {
        professions: data
      }
    case 'patientProfessions':
      return {
        patientProfessions: data
      }
    default:
      return {}
  }
}

const patientManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_PATIENT_MANAGEMENT_TYPE_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_PATIENT_MANAGEMENT_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        patientsManagementType: action.payload,
        ...mappingDataByModule(action.module, action.payload)
      }
    case LIST_PATIENT_MANAGEMENT_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        patientsManagementType: action?.dummy
      }
    default:
      return state
  }
}

export default patientManagementReducer
